import Vue from 'vue';
import App from './App.vue';
import router from './router/index';
import store from './store'
import ElementUI, { Message, MessageBox, Notification, Loading } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { initGlobalState , registerMicroApps, start } from 'qiankun';
// import MySharedComponent from '@/components/HelloWorld.vue';
import AdminExamReport from '@/views/Exam/ExamReport.vue';
import AdminExamStudentDetail from '@/views/Exam/ExamStudentDetail.vue';
Vue.config.productionTip = false;
// 全局注入常量数据
import constGlobal from './common/constGlobal.js'
Vue.use(constGlobal);
Vue.use(ElementUI);

// 配置 Element UI 原型方法
Vue.prototype.$ELEMENT = { size: 'medium', zIndex: 3000 };
Vue.prototype.$loading = Loading.service;
Vue.prototype.$message = Message;
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$prompt = MessageBox.prompt;
Vue.prototype.$notify = Notification;

import './common/directives';
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
const initialState = {
  component:{}
 };
const actions = initGlobalState(initialState);
// 更新共享组件注册表
actions.setGlobalState({
  parameter:{
  },
  component: {
    //考试报表
    AdminExamReport,
    AdminExamStudentDetail,//考试记录下的参考学员信息
  },
});
// // 出于演示目的，监听全局状态变化
actions.onGlobalStateChange((state, prev) => {
  store.commit('updateParameter', state.parameter);
  store.commit('updateToken', state.token);
  // console.log('主应用状态变化:', state, prev);
});
// 导出 actions 供其他模块使用
export default actions;
// 设置浏览器标题
Vue.directive('title', {
  inserted: function (el, binding) {
    document.title = el.dataset.title
  }
})
